import { SparklesIcon } from 'lucide-react';

import { PagePlaceholder } from '@/shared/components/PagePlaceholder';

export function AgentsSkillsPage() {
  return (
    <PagePlaceholder
      eyebrow="Workspace"
      title="Agents & Skills"
      description="The agents and skills installed in this workspace, stored as files here and managed as product resources."
      icon={SparklesIcon}
    />
  );
}
